<template>
  <div class="paging">
    <span style="color: #ff6600" v-if="sq" @click="$emit('pageupdata',1);">
      收起<i class="el-icon-caret-top"></i>
    </span>
    <span style="color: #b79255;margin-left: 10px" v-if="gd" @click="$emit('pageupdata','');">
      更多<i class="el-icon-caret-bottom"></i>
    </span>
  </div>
</template>

<script>
export default {
  name: "paging",
  props:{
    sq:Boolean,
    gd:Boolean,
  }
}
</script>

<style lang="scss" scoped>

.paging {
  text-align: center;
  padding-top: 10px;
  span {
    display: inline-block;
    margin-bottom: 10px;
    cursor: pointer;
  }
}
</style>
